import { render, staticRenderFns } from "./combobox.vue?vue&type=template&id=b80d65de"
import script from "./combobox.vue?vue&type=script&lang=js"
export * from "./combobox.vue?vue&type=script&lang=js"
import style0 from "./combobox.vue?vue&type=style&index=0&id=b80d65de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports